import { render, staticRenderFns } from "./reasonForRejectionModal.vue?vue&type=template&id=e882df4c"
import script from "./reasonForRejectionModal.vue?vue&type=script&lang=js"
export * from "./reasonForRejectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports